if (!customElements.get('eci-sold-request')) {
  customElements.define('eci-sold-request', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const open = () => { if (!dialog.open) dialog.showModal(); };
      const close = () => dialog.close();
      this.querySelectorAll('[data-eci-sold-open]').forEach(button => button.addEventListener('click', open, options));
      this.querySelectorAll('[data-eci-sold-close]').forEach(button => button.addEventListener('click', close, options));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }, options);
      if (dialog.querySelector('[data-eci-autoopen]')) open();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
